<template>
  <div class="home">
    <div class="section hero">
     <HeroPage/>
    </div>
    <div class="section intro">
      <IntroductionPage/>
    </div>
    <div class="section technologies">
      <TechnologiesPage/>
    </div>

    <div class="section work">
      <WorkEducationPage/>
    </div>
    <div class="section projects">
      <ProjectsPage/>
    </div>
    <div class="section contact">
      <ContactsPage/>
    </div>
    
  </div>
</template>

<script>
import ContactsPage from '@/components/ContactsPage.vue';
import HeroPage from '@/components/HeroPage.vue';
import IntroductionPage from '@/components/IntroductionPage.vue';
import ProjectsPage from '@/components/ProjectsPage.vue';
import TechnologiesPage from '@/components/TechnologiesPage.vue';
import WorkEducationPage from '@/components/WorkEducationPage.vue';

export default {
  name: 'HomeView',
  components: {
    HeroPage,
   IntroductionPage, TechnologiesPage,
   WorkEducationPage, ProjectsPage,
   ContactsPage
  }
}
</script>
<style scoped>
.intro{
  background: var(--light);
  
}

.intro .technologies{
  min-height:8rem;
  
}




.hero{
  background:var(--image),var(--blue);
  background-blend-mode:overlay;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  display:flex;
  align-items: center;
  justify-content: center;

}


@media(max-width: 768px){
  
.hero{
  padding:2rem;
}

.heading{
  font-size:3.5rem;
  max-width:40rem;
  margin-top:1rem;
  color:white;
}

}


</style>
